import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from 'react-router-dom';

interface ChristmasOfferBannerProps {
  onClose: () => void;
}

export const ChristmasOfferBanner: React.FC<ChristmasOfferBannerProps> = React.memo(({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = React.useCallback((e: React.MouseEvent<HTMLAnchorElement>, path: { 'sv-se': string; 'en-us': string }) => {
    e.preventDefault();
    navigate(
      getLocalizedPathFromLocalStorage(
        { get: (key: string) => getItem(key) ?? null },
        path
      )
    );
  }, [navigate]);

  return (
    <div className="christmas-offer-wrapper">
      <Row className="justify-content-center">
        <Col xs={12} className="px-0">
          <div className="christmas-offer-banner d-flex align-items-center justify-content-center py-2 position-relative">
            <p className="my-0 text-center christmas-offer-text">
              <span className="fw-bold">🎁 <b>{t('LIMITED_OFFER')}:</b></span>
              <span> {t('ALL_NEW_AND_EXISTING_USERS_GET')}</span>
              <span className="fw-bold"><b> {t('3_FREE_INVOICES')} </b></span>
              <a 
                href={getLocalizedPathFromLocalStorage(
                  { get: (key: string) => getItem(key) ?? null },
                  { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' }
                )}
                onClick={(e) => handleNavigation(e, { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' })}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              > 
                <b>{t('HERO_LOGIN')}</b>
              </a>
              <span> {t('HERO_OR')} </span>
              <a  
                href={getLocalizedPathFromLocalStorage(
                  { get: (key: string) => getItem(key) ?? null },
                  { 'sv-se': 'e-postregister', 'en-us': 'emailregister' }
                )}
                onClick={(e) => handleNavigation(e, { 'sv-se': 'e-postregister', 'en-us': 'emailregister' })}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              > 
                <b>{t('HERO_CREATE_AND_ACCOUNT')}</b>
              </a>
              <span> {t('HERO_TO_GET_YOUR_BONUS')} </span>
            </p>
            <button 
              className="christmas-offer-close"
              onClick={onClose}
              aria-label="Close Christmas offer"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#0A0D12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
});
